import { ReactNode } from "react";

import { ComplianceProgramActionCalibrationGroupItemProps } from "@apps/programs/helpers";
import { TopicflowIcon } from "@components/topicflow-icon/topicflow-icon";

import ComplianceProgramActionItem from "./compliance-program-action-item";

const ComplianceProgramActionItemForCalibration = ({
  item,
  children,
}: {
  item: ComplianceProgramActionCalibrationGroupItemProps;
  children?: ReactNode;
}) => {
  const { group } = item;

  return (
    <ComplianceProgramActionItem
      label={group.name}
      icon={
        <div className="flex items-center p-1 bg-gray-100 rounded-full shrink-0">
          <TopicflowIcon type="users" className="h-4 w-4 text-gray-600" />
        </div>
      }
      buttonProps={item.buttonProps}
    >
      {children}
    </ComplianceProgramActionItem>
  );
};

export default ComplianceProgramActionItemForCalibration;
